import { fetchCenterDetailsQueryOptions } from '@avanta/shared/hooks/useFetchCenterDetails';
import { fetchPsychologistDetailsQueryOptions } from '@avanta/shared/hooks/useFetchPsychologistDetails';
import { useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import { useLocation } from 'react-router';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { type Appointment } from 'types/appointments';

export const useFetchAppointmentByPatient = (): UseQueryResult<Appointment> => {
  const { state } = useLocation();
  const queryClient = useQueryClient();
  const patientId = state?.appointment?.patientId;
  const appointmentId = state?.appointment?.id;

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_APPOINTMENT_BY_PATIENT, patientId, appointmentId],
    queryFn: async () => {
      const { data: appointment } = await AppointmentService.getAppointmentByPatient({
        appointmentId,
        patientId,
      });

      const [psychologist, center] = await Promise.all([
        queryClient.fetchQuery(fetchPsychologistDetailsQueryOptions(appointment.psychologistId)),
        queryClient.fetchQuery(fetchCenterDetailsQueryOptions(appointment.backofficeCenterId)),
      ]);

      return {
        ...appointment,
        psychologist: { psychologist },
        center,
      };
    },
    enabled: !!patientId && !!appointmentId,
  });
};
